import { Component } from '@angular/core';
import {
  AsyncPipe,
  DatePipe,
  Location,
  NgClass,
  NgStyle,
} from '@angular/common';
import { Job } from '../../class/job.class';
import { ActivatedRoute, Router } from '@angular/router';
import { StatusChipComponent } from '../../components/status-chip/status-chip.component';
import { TaskEnum } from '../../enums/task.enum';
import { JobService } from '../../services/job.service';
import { Store } from '@ngrx/store';
import { JobsActions } from '../../store/jobs/jobs.actions';
import { Observable } from 'rxjs';
import { selectJobById, selectJobIsCompleted } from '../../store/jobs/jobs.selects';
import { environment } from '../../../environments/environment';
import { LucideAngularModule } from 'lucide-angular';
import { StepperComponent } from '../../components/stepper/stepper.component';
import { Task } from '../../class/task.class';
import { TimerPipe } from '../../pipes/timer.pipe';
import { DomSanitizer } from '@angular/platform-browser';
import { ResponsiveService } from '../../services/reponsive.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonComponent } from '../../components/boutons/button/button.component';
import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { ConfirmModalComponent } from '../../components/modals/confirm-modal/confirm-modal.component';
import { DownloadService } from '../../services/download.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
@Component({
  selector: 'app-job',
  imports: [StepperComponent,  LucideAngularModule,LottieComponent, NgClass, NgStyle, ButtonComponent,TranslateModule, StatusChipComponent, TimerPipe, AsyncPipe, DatePipe, TranslateModule],
  templateUrl: './job-detail.component.html',
  styleUrl: './job-detail.component.scss'
})
export class JobDetailComponent {
  job$: Observable<Job | undefined> = new Observable<Job | undefined>();
  taskCount: number = 0;

// Responsives
  smallScreen$: Observable<boolean> = this.responsiveService.small$;
  mediumScreen$: Observable<boolean> = this.responsiveService.desktop$;
  largeScreen$: Observable<boolean> = this.responsiveService.largeDesktop$;

  options: AnimationOptions = {
    path: '/assets/animations/svet-loader.json',
  };

  resultUrl: string | undefined;

  videoUrl: string = '';
  isLoading: boolean = true;
  hasError: boolean = false;
  downloadProgress: number = 0;
  showProgress: boolean = true;

  jobCompleted$: Observable<boolean> = new Observable<boolean>();

  constructor(
    public location: Location,
    private router: Router,
    private route: ActivatedRoute,
    private jobService: JobService,
    private store: Store,
    protected sanitizer: DomSanitizer,
    private responsiveService: ResponsiveService,
    private dialog: Dialog,
    private translateService: TranslateService,
    public downloadService:DownloadService,
  ) { }

  downloadFinalUrl(jobId: number, fileExtention: string): string {
    return `${environment.apiUrl}/script/assets/${jobId}/videoFinal${fileExtention}`
  }

  getIcon(task: Task): string {
    switch (task.status) {
      case 'ERROR':
        return 'circle-alert'

      case 'COMPLETED':
        return 'circle-check-big'

      case 'PENDING':
        return 'clock'

      default:
        return 'circle'
    }
  }

  deleteJob(jobId: number) {
    this.jobService.delete(jobId).subscribe({
      next: () => {
        this.router.navigate(['/dashboard/my-jobs']);
        this.store.dispatch(JobsActions.removeJob({ jobId }))
      },
    })
  }

  
  openDeleteJobModal(jobId: number): void {
    const dialogRef:DialogRef<unknown, ConfirmModalComponent> = this.dialog.open(ConfirmModalComponent, {
      width: '500px'
    });
    const confirmModalComponent = dialogRef.componentInstance as ConfirmModalComponent;
   confirmModalComponent.content = this.translateService.instant('modal.delete_job.content');
   confirmModalComponent.confirm = this.translateService.instant('modal.delete_job.confirm');;
   confirmModalComponent.onConfirm.subscribe(() => {
      this.deleteJob(jobId);
      dialogRef.close();
    });
  }

  ngOnDestroy() {
    // Nettoyer l'URL créée pour éviter les fuites mémoire
    if (this.videoUrl) {
      URL.revokeObjectURL(this.videoUrl);
    }
  }

  loadVideo(jobId:number):void {
    this.isLoading = true;
    this.hasError = false;

    this.downloadService.getVideoFinalStream(jobId).subscribe({
      next: (blob) => {
        this.videoUrl = URL.createObjectURL(blob);
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Erreur lors du chargement de la vidéo:', error);
        this.hasError = true;
        this.isLoading = false;
      }
    });
  }

  loadVideoWithProgress(jobId:number) {
    this.isLoading = true;
    this.hasError = false;
    this.showProgress = true;
    this.downloadProgress = 0;

    this.downloadService.getVideoWithProgress(jobId).subscribe({
      next: (event:HttpEvent<Blob>) => {
        console.log(event)
        switch (event.type) {
          case HttpEventType.DownloadProgress:
            console.log('Progression du téléchargement:', event);
            if (event.total) {
              this.downloadProgress = Math.round(100 * event.loaded / event.total);
            }
            break;
          case HttpEventType.Response:
            if (event.body) {
              this.videoUrl = URL.createObjectURL(event.body);
              this.isLoading = false;
              this.showProgress = false;
            }
            break;
        }
      },
      error: (error) => {
        console.error('Erreur lors du chargement avec progress:', error);
        this.hasError = true;
        this.isLoading = false;
        this.showProgress = false;
      }
    });
  }

  onVideoError(event: any) {
    this.hasError = true;
    console.error('Erreur lors de la lecture de la vidéo:', event);
  }

  retryLoad(jobId:number) {
    this.loadVideoWithProgress(jobId);
  }

  ngOnInit(): void {
    const jobId: string = this.route.snapshot.params['id'];
    if (jobId) {
      this.job$ = this.store.select(selectJobById(parseInt(jobId)))
      this.jobCompleted$ = this.store.select(selectJobIsCompleted(parseInt(jobId)));
      this.taskCount = Object.keys(TaskEnum).length / 2;
      this.job$.subscribe({
        next: (job: Job | undefined) => {
          if (job && job.completed) {
            this.loadVideoWithProgress(job.id)
          }
        }
      })
      return
    }
    this.router.navigate(['/dashboard/my-jobs']);
    return;
  }
}

